export default __webpack_public_path__ + "static/xulia-bd44af37cde0c10349dd116babcf2372.jpg";